import { Context, Logger } from '@vue-storefront/core';
import { IUseVINSearchRefs } from '@composables/src/useVINSearch/types';

const getVehiclesByVIN = (context: Context, refs: IUseVINSearchRefs) => async (vin: string) => {
  Logger.debug(`useVINSearch/getVINDetails`);

  try {
    refs.result.value = null;
    refs.error.value = null;
    refs.loading.value = true;
    const {
      $partsDb: { api },
    } = context;

    const response = await api.getVehiclesByVIN(vin);
    refs.result.value = response.result;
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 404) {
      refs.result.value = [];
      return;
    }
    refs.error.value = new Error('Failed to get vehicles by VIN.');
    Logger.error(`useVINSearch/getVINDetails/error`, error);
  } finally {
    refs.loading.value = false;
  }
};

export default getVehiclesByVIN;
